import client from './main-client';

export const getDashboardCompaniesApi = (data) => client().get(`dashboard-companies?companyName=${data.companyName}`);
